import React from "react";
import { inject, observer } from 'mobx-react'
import {Component} from "react/lib/ReactBaseClasses";
import ValidacaoStore from "../stores/ValidacaoStore";
import moment from "moment/moment";
import {FormGroup} from "reactstrap";
import {formatarValorReal} from "../../../utils/formatar";

@inject("store")
@observer
export class Validacao extends Component {
    constructor(props) {
        super(props);
        this.store = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.formStore = this.props.store.formStore;
    }

    componentWillUnmount() {
        this.store.resetDados(this.props.id);
    }

    block_submit(campo){
        this.store.campoValid(campo, false);
    };

    getMensagemErro(tipo) {
        return this.store.getMensagemErro(tipo, this.props.mensagem);
    }

    render() {
        this.store.campoValid(this.props.id, true);

        const erro = [];
        let tipo = this.props.tipo;
        let index = -1;

        if(tipo.length> 0) {
            tipo.findIndex((tipo) => tipo === "isRequired" && this.props.valor !== 0 && typeof this.props.valor !== "boolean" && !this.props.valor && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isBooleanRequired" && !this.props.valor && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isRequiredMonthYearDate" && !(this.props.valor && this.props.valor.year && this.props.valor.month) && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isArrayNotEmpty" && this.props.valor && this.props.valor.length < 1 && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isEmail" && !this.store.isEmail(this.props.valor) && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "areEmails" && !this.store.areEmails(this.props.valor) && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isCPF" && !this.store.isCPF(this.props.valor) && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isDate" && !this.store.isDate(this.props.valor) && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            tipo.findIndex((tipo) => tipo === "isArrayUnique" && !this.store.isArrayUnique(this.props.valor) && erro.push(this.getMensagemErro(tipo)) && this.block_submit(this.props.id));

            if(tipo.findIndex((tipo) => tipo === "maxLength") === 0){
                if(this.props.valor.length > tipo[1]){
                    erro.push(this.getMensagemErro(tipo));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "quantidadeMin")) > -1){
                if(this.props.valor ===0 ||(this.props.valor && tipo[index+1] && this.props.valor < tipo[index+1])){
                    erro.push(this.getMensagemErro([tipo[index], " ("+tipo[index+1]+")"]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "quantidadeMax")) > -1){
                if(this.props.valor && tipo[index+1] && this.props.valor > tipo[index+1]){
                    erro.push(this.getMensagemErro([tipo[index], " ("+tipo[index+1]+")"]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "empregadosSubstituidosMax")) > -1){
                const valor = this.props.valor.length;
                if(tipo[index+1] && valor > tipo[index+1]){
                    erro.push(this.getMensagemErro(tipo[index]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "empregadosSubstituidosMin")) > -1){
                const valor = this.props.valor.length;
                if(valor < tipo[index+1]){
                    erro.push(this.getMensagemErro(tipo[index]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "salarioMin")) > -1){
                if(this.props.valor ===0 ||(this.props.valor && this.props.valor < tipo[index+1])){
                    erro.push(this.getMensagemErro([tipo[index], " ("+formatarValorReal(tipo[index+1])+")"]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "salarioMaiorQue")) > -1){
                if(this.props.valor === 0 ||(this.props.valor && this.props.valor <= tipo[index+1])){
                    erro.push(this.getMensagemErro([tipo[index], " ("+formatarValorReal(tipo[index+1])+")"]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "salarioMax")) > -1){
                if(this.props.valor && tipo[index+1] && this.props.valor > tipo[index+1]){
                    erro.push(this.getMensagemErro([tipo[index], " ("+formatarValorReal(tipo[index+1])+")"]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "quantidadedeDias")) > -1){
                if(this.props.valor && this.props.valor < tipo[index-1]){
                    erro.push(this.getMensagemErro(tipo[index-2]));
                    this.block_submit(this.props.id)
                }
                if(this.props.valor && this.props.valor > tipo[index-3]){
                    erro.push(this.getMensagemErro(tipo[index-4]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "SolicDiasMin")) > -1){
                if(this.props.valor) {
                    const hoje = moment(tipo[index + 2], 'DD-MM-YYYY');
                    const solicitacao = moment(this.props.valor, 'DD-MM-YYYY');
                    const diferenca = solicitacao.diff(hoje, 'days')
                    if(diferenca<tipo[index + 1]){
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "SolicDiasMax")) > -1){
                if(this.props.valor) {
                    const hoje = moment(tipo[index + 2], 'DD-MM-YYYY');
                    const solicitacao = moment(this.props.valor, 'DD-MM-YYYY');
                    const diferenca = solicitacao.diff(hoje, 'days')
                    if(diferenca>tipo[index + 1]){
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "endDateAfter")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    const dataInicio = moment(tipo[index + 1], 'DD-MM-YYYY');
                    const dataTermino = moment(this.props.valor, 'DD-MM-YYYY');
                    if(this.store.isDate(this.props.valor)) {
                        if (!dataTermino.isAfter(dataInicio)) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "endDateSame")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    const dataInicio = moment(tipo[index + 1], 'DD/MM/YYYY');
                    const dataTermino = moment(this.props.valor, 'DD/MM/YYYY');
                    if(this.store.isDate(this.props.valor)) {
                        if (dataTermino.isSameOrBefore(dataInicio)) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "endDateSameOrAfter")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    const dataInicio = moment(tipo[index + 1], 'DD-MM-YYYY');
                    const dataTermino = moment(this.props.valor, 'DD-MM-YYYY');
                    if(this.store.isDate(this.props.valor)) {
                        if (!dataTermino.isSameOrAfter(dataInicio)) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "endDateMax1Month")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    const dataInicio = moment(tipo[index + 1], 'DD-MM-YYYY');
                    const dataTermino = moment(this.props.valor, 'DD-MM-YYYY');
                    if(this.store.isDate(this.props.valor)) {
                        if (dataTermino.diff(dataInicio, 'months', true) > 1) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "endDateMax3Month")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    const dataInicio = moment(tipo[index + 1], 'DD-MM-YYYY');
                    const dataTermino = moment(this.props.valor, 'DD-MM-YYYY');
                    if(this.store.isDate(this.props.valor)) {
                        if (dataTermino.diff(dataInicio, 'months', true) > 2) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "endDateMax12Months")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    const dataInicio = moment(tipo[index + 1], 'DD-MM-YYYY');
                    const dataTermino = moment(this.props.valor, 'DD-MM-YYYY');
                    if(this.store.isDate(this.props.valor)) {
                        if (dataTermino.diff(dataInicio, 'months', true) > 12) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "empregadosGestores")) > -1){
                if(this.props.valor) {
                    for(let i=0;i<this.props.valor.length;i++){
                        if(this.props.valor[i] && !this.props.valor[i].gestor){
                            erro.push("Empregado com matrícula "+this.props.valor[i].matricula+ " não é gestor");
                            this.block_submit(this.props.id);
                            break;
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "empregadoGestor")) > -1){
                if(this.props.valor && (this.props.valor.nh === 'EQUIPE' || this.props.valor.nh === 'EQUIPE TECNICO OPERACIONAL')){
                    erro.push("Empregado com matrícula "+this.props.valor.matricula+ " não é gestor");
                    this.block_submit(this.props.id);
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "mesmoCPF")) > -1){
                if(this.props.valor === tipo[index+1]){
                    erro.push(this.getMensagemErro(tipo[index]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "compararDataAnterior")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    let data1 = moment(this.props.valor, 'DD-MM-YYYY');
                    let data2 = moment(tipo[index + 1], 'DD-MM-YYYY');
                    data1 = (moment(data1.format('DD-MM-YYYY'), 'DD-MM-YYYY'))
                    data2 = (moment(data2.format('DD-MM-YYYY'), 'DD-MM-YYYY'))
                    if(this.store.isDate(this.props.valor)) {
                        if (data2.isAfter(data1)) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "compararDataPosterior")) > -1){
                if(this.props.valor && tipo[index + 1]) {
                    let data1 = moment(this.props.valor, 'DD-MM-YYYY');
                    let data2 = moment(tipo[index + 1], 'DD-MM-YYYY');
                    data1 = (moment(data1.format('DD-MM-YYYY'), 'DD-MM-YYYY'))
                    data2 = (moment(data2.format('DD-MM-YYYY'), 'DD-MM-YYYY'))
                    if(this.store.isDate(this.props.valor)) {
                        if (data1.isAfter(data2)) {
                            erro.push(this.getMensagemErro(tipo[index]));
                            this.block_submit(this.props.id)
                        }
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "empregadosMesmoCargo")) > -1){
                if(this.props.valor) {
                    const cargos = this.props.valor.map(x => x.cargo.id)
                    if(! cargos.every( (val, i, arr) => val === arr[0])){
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "mesmaJustificativa")) > -1){
                if(this.props.valor &&  tipo[index + 1]) {
                    erro.push(this.getMensagemErro(tipo[index]));
                    this.block_submit(this.props.id)
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "isIdadeValida")) > -1){
                if(this.props.valor) {
                    let data1 = moment(this.props.valor, 'DD/MM/YYYY');
                    let years = moment().diff(data1, 'years');
                    if( years < 16 ) {
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    } else if( years > 120 ){
                        erro.push(this.getMensagemErro("isDate"));
                        this.block_submit(this.props.id)
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "compararDatasRestritas")) > -1){
                if(this.props.valor && tipo[index + 1]) {

                    let dataInformada = moment(this.props.valor, 'DD-MM-YYYY');
                    let datasRestritas = tipo[index + 1];

                    //verifica e bloqueia data informada dentro das datas restritas
                    if (datasRestritas.some((datas) => dataInformada.isSame(datas, 'day'))){
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "justificativaCusteioDireto")) > -1){
                if(this.props.valor && tipo[index + 1]) {

                    let bloqueioJustificativaCusteioDireto = tipo[index + 1];

                    //verifica e bloqueia a justificativa de custeio direto se não for GL Mediapulse
                    if (bloqueioJustificativaCusteioDireto != null && bloqueioJustificativaCusteioDireto){
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    }
                }
            }

            if((index = tipo.findIndex((tipo) => tipo === "salarioBaseCargoInvalido")) > -1){
                if(this.props.valor) {

                    const salarioBase = tipo[index + 1];

                    //verifica e bloqueia se o cargo não tem salario Base
                    if (salarioBase === null || salarioBase == ""){
                        erro.push(this.getMensagemErro(tipo[index]));
                        this.block_submit(this.props.id)
                    }
                }
            }

        }

        this.store.submitStatus();

        return (<div>
                {this.props.children}
                {(this.modalStore.submitted || this.formStore.submitted) && erro.map((item, index) => {
                    if (this.props.isGroupValidation) {
                        return <FormGroup>
                            <span key={index} style={{color: 'red', display: 'block'}}>{item}</span>
                        </FormGroup>
                    } else {
                        return <span key={index} style={{color: 'red', display: 'block'}}>{item}</span>
                    }
                })}
            </div>
        );
    }
}
